// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "money.snowball",
    name: "Snowball",
    homepage: "https://snowball.money/",
    image_id: "313faea4-af8c-41f4-0ed8-98be5d048e00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/snowball-smart-defi-wallet/id1449662311",
        android: "https://play.google.com/store/apps/details?id=money.snowball.defi",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://app.snowball.exchange/app",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map